import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "flag-icons/css/flag-icons.min.css";
import "./PhoneInputStyles.css";

interface CustomPhoneInputProps {
  value: string;
  onChange: (value: string | undefined) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  error?: boolean;
  id?: string;
  autoComplete?: string;
}

const CustomPhoneInput: React.FC<CustomPhoneInputProps> = ({
  value,
  onChange,
  onBlur,
  placeholder = "Enter phone number",
  disabled = false,
  className = "",
  error = false,
  id,
  autoComplete = "tel",
}) => {
  const handleChange = (value: string | undefined) => {
    onChange(value || "");
  };

  return (
    <div className="phone-input-wrapper">
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="IN"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        id={id}
        autoComplete={autoComplete}
        className={`
          phone-input
          ${className}
          ${error ? "phone-input-error" : ""}
          ${disabled ? "phone-input-disabled" : ""}
        `.trim()}
      />
    </div>
  );
};

export default CustomPhoneInput;